import { render, staticRenderFns } from "./SelectSubjectPublic.vue?vue&type=template&id=a295b7d8&"
import script from "./SelectSubjectPublic.vue?vue&type=script&lang=js&"
export * from "./SelectSubjectPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a295b7d8')) {
      api.createRecord('a295b7d8', component.options)
    } else {
      api.reload('a295b7d8', component.options)
    }
    module.hot.accept("./SelectSubjectPublic.vue?vue&type=template&id=a295b7d8&", function () {
      api.rerender('a295b7d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/subjects/SelectSubjectPublic.vue"
export default component.exports